import { render, staticRenderFns } from "./RatingBar.vue?vue&type=template&id=db98b50e&scoped=true"
import script from "./RatingBar.vue?vue&type=script&lang=ts"
export * from "./RatingBar.vue?vue&type=script&lang=ts"
import style0 from "./RatingBar.vue?vue&type=style&index=0&id=db98b50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@4.3.0_lodash@4.17.21_prettier@2.8.8_react-dom@18.3.1_react@17.0_5ioacul63gvtxmolb2qhpey7py/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db98b50e",
  null
  
)

export default component.exports